import {
  Pipe,
  PipeTransform,
} from '@angular/core';
import {Constants} from '../constants/constants';
import {NumberConverter} from '../functions/number-converter';

@Pipe({
  name: 'pasteApostropheWithFixedDecimals',
})
export class PasteApostropheWithFixedDecimalsPipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || !Number.isFinite(+value)) {
      return Constants.DASH;
    }
    return NumberConverter.pasteApostropheWithFixedDecimals(value);
  }

}
